<script setup lang="ts">
  import { reactiveOmit } from '@vueuse/core';
  import type { TagsInputItemDeleteProps } from 'reka-ui';
  import { TagsInputItemDelete, useForwardProps } from 'reka-ui';
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  const props = defineProps<TagsInputItemDeleteProps & { class?: HTMLAttributes['class'] }>();

  const delegatedProps = reactiveOmit(props, 'class');

  const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <TagsInputItemDelete
    v-bind="forwardedProps"
    :class="cn('flex rounded bg-transparent mr-1', props.class)"
  >
    <slot>
      <i class="w-4 fa far fa-times text-2xs" />
    </slot>
  </TagsInputItemDelete>
</template>
